import { withStyles } from '@material-ui/styles';
import { flowRight } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import styles from '../styles/otherSettings';
import { actions as reduxActions } from '../reducers';
import { updateTelephonyUserOnSubmit } from '../actions/updateTelephonyUser';
import DataCheckboxRow from '../../../partials/dataBox/DataCheckboxRow';
import { translate } from '../../../i18n/I18nProvider';
import { isDefined } from '../../../utils/isDefined';

const OtherSettings = ({ form, classes, licenses = {} }) => {
  return (
    <div className={classes.root}>
      <div className={classes.label}>
        {translate('USER.ALLOWED_APPLICATIONS')}
      </div>
      <div className={classes.content}>
        <div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>Tablet</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_IPAD')}
              name="ipad_support"
              {...form}
            />
          </div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>Premium Supervision</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_PREMIUM_SUPERVISION')}
              name="premium_intrusion"
              {...form}
            />
          </div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>Premium Attendant</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_PREMIUM_ATTENDANT')}
              name="premium_attendant"
              disabled={
                isDefined(licenses?.premiumAttendant) &&
                licenses?.premiumAttendant === false
              }
              {...form}
            />
          </div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>Call control APIs</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_CALL_CONTROL_API')}
              name="call_control_api"
              disabled={
                isDefined(licenses?.callControlApi) &&
                licenses?.callControlApi === false
              }
              {...form}
            />
            <DataCheckboxRow
              label={translate('USER.ENABLE_CLOUD_CTI_API')}
              name="cloud_cti_api"
              disabled={
                isDefined(licenses?.cloudCtiApi) &&
                licenses?.cloudCtiApi === false
              }
              {...form}
            />
          </div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>Line State API</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_LINE_STATE_API')}
              name="line_state_api"
              disabled={
                isDefined(licenses?.lineStateApi) &&
                licenses?.lineStateApi === false
              }
              {...form}
            />
          </div>
        </div>
        <div>
          <div className={classes.box}>
            <div className={classes.boxLabel}>CRM Connect</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_CRM_CONNECT')}
              name="crm_connect"
              disabled={
                isDefined(licenses?.crmConnect) &&
                licenses?.crmConnect === false
              }
              {...form}
            />
          </div>

          <div className={classes.box}>
            <div className={classes.boxLabel}>Unified inbox</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_UNIFIED_INBOX')}
              name="unified_inbox"
              {...form}
            />
          </div>

          <div className={classes.box}>
            <div className={classes.boxLabel}>3rd party CRM Connector</div>
            <DataCheckboxRow
              label={translate('USER.3RD_PARTY_CRM_CONNECTOR')}
              name="cloud_crm_connector"
              disabled={
                isDefined(licenses?.thirdPartyCrmConnector) &&
                licenses?.thirdPartyCrmConnector === false
              }
              {...form}
            />
          </div>

          <div className={classes.box}>
            <div className={classes.boxLabel}>Chat</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_CHAT')}
              name="chat"
              disabled={isDefined(licenses?.chat) && licenses?.chat === false}
              {...form}
            />
          </div>

          <div className={classes.box}>
            <div className={classes.boxLabel}>Teams</div>
            <DataCheckboxRow
              label={translate('USER.ENABLE_TEAMS_APPLICATION')}
              name="teams_application"
              disabled={isDefined(licenses?.teams) && licenses?.teams === false}
              {...form}
            />
            <DataCheckboxRow
              label={translate('USER.ENABLE_TEAMS_TELEPHONY')}
              name="teams_telephony"
              disabled={isDefined(licenses?.teams) && licenses?.teams === false}
              {...form}
            />
            <DataCheckboxRow
              label={translate('USER.ENABLE_TEAMS_TELEPHONY_APP')}
              name="teams_telephony_go"
              disabled={isDefined(licenses?.teams) && licenses?.teams === false}
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editUser, selectClient }) => {
  return {
    ...editUser,
    generalData: editUser.user.generalData,
    clientId: selectClient.selectedClient.id
  };
};

const mapDispatchToProps = {
  ...reduxActions,
  updateTelephonyUserOnSubmit
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(OtherSettings);
